export const getIsEnabled = (isAdmin: boolean, type?: string) => {
  if (!type) return false;
  if (type === "rl") return false;
  if (type === "shared" && !isAdmin) return false;
  return true;
};
